import { render } from "./SelfLeaveManage.vue?vue&type=template&id=8a6a5910"
import script from "./SelfLeaveManage.vue?vue&type=script&lang=js"
export * from "./SelfLeaveManage.vue?vue&type=script&lang=js"

import "./SelfLeaveManage.vue?vue&type=style&index=0&id=8a6a5910&lang=less"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__